import { render, staticRenderFns } from "./RecipientContacts.vue?vue&type=template&id=7532e728&scoped=true"
import script from "./RecipientContacts.vue?vue&type=script&lang=js"
export * from "./RecipientContacts.vue?vue&type=script&lang=js"
import style0 from "./ds-common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RecipientContacts.vue?vue&type=style&index=1&id=7532e728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7532e728",
  null
  
)

export default component.exports